export default {
  uploadButtonWrapper: 'batch-upload-button-wrapper',
  uploadButtonIcon: 'batch-upload-button-icon',
  uploadButtonTitle: 'batch-upload-button-title',
  uploadButtonText: 'batch-upload-button-text',
  uploadButtonInput: 'batch-upload-button-input',
};
